import Chart from 'chart.js';

const allChartColors = [
  '#5FC0A4', '#F1F08C', '#DEBE78', '#B88551', '#F37E80',
  '#545D6F', '#ACC7AC', '#779085', '#55696C', '#311E2A',
];

const emptyColor = [
  '#a8a8a8',
];

const chartColors = (size) => {
  let colors = allChartColors;
  while (colors.length < size) {
    colors = colors.concat(allChartColors);
  }
  return colors.slice(0, size);
};

const baseOptions = {
  responsive: true,
  legend: {
    position: 'left',
    labels: {
      fontSize: 18,
    },
  },
};

export const updateStatusChart = (el, ballotsSubmitted, ballotsRemaining) => {
  window.chart.data.datasets.forEach((dataset) => {
    dataset.data[0] = ballotsSubmitted; // eslint-disable-line no-param-reassign
    dataset.data[1] = ballotsRemaining; // eslint-disable-line no-param-reassign
  });
  window.chart.update();
};

export const statusChart = (el, ballotsSubmitted, ballotsRemaining) => {
  const ctx = el.getContext('2d');
  window.chart = new Chart(ctx, {
    type: 'doughnut',
    data: {
      datasets: [
        {
          data: [ballotsSubmitted, ballotsRemaining],
          backgroundColor: chartColors(1).concat(['#CED4DA']),
        },
      ],
      labels: ['Submitted', 'Remaining'],
    },
    options: {
      ...baseOptions,
      cutoutPercentage: 85,
      responsive: true,
      events: [],
      legend: {
        display: false,
      },
    },
  });
};

export const attendanceChart = (el, checkedInCount, checkedOutCount) => {
  const ctx = el.getContext('2d');
  new Chart(ctx, { // eslint-disable-line no-new
    type: 'pie',
    data: {
      datasets: [
        {
          data: [checkedInCount, checkedOutCount],
          backgroundColor: chartColors(2),
        },
      ],
      labels: ['Checked-In', 'Checked-Out'],
    },
    options: {
      ...baseOptions,
      responsive: true,
      legend: {
        display: false,
      },
    },
  });
};

export const ballotResultsChart = (el, data, labels) => {
  const ctx = el.getContext('2d');
  new Chart(ctx, { // eslint-disable-line no-new
    type: 'polarArea',
    data: {
      datasets: [
        {
          data,
          backgroundColor: chartColors(data.size),
        },
      ],
      labels,
    },
    options: {
      ...baseOptions,
      tooltips: {
        callbacks: {
          label: (tooltipItem, chartData) => `${chartData.labels[tooltipItem.index]}: ${tooltipItem.label} % of Vote`,
        },
      },
      legend: {
        position: 'left',
        labels: {
          fontColor: 'black',
          fontSize: 22,
        },
      },
      scale: {
        gridLines: {
          z: 1,
        },
        ticks: {
          min: 0,
          max: 100,
          z: 1,
          callback: (value) => `${value}%`,
        },
        afterBuildTicks: (humdaysChart) => {
          humdaysChart.ticks = [0, $(el).attr('data-majority') * 100, 100]; // eslint-disable-line no-param-reassign
          return humdaysChart;
        },
      },
    },
  });
};

export const specialStatesChart = (el, data, labels) => {
  const ctx = el.getContext('2d');
  new Chart(ctx, { // eslint-disable-line no-new
    type: 'pie',
    data: {
      datasets: [
        {
          data,
          backgroundColor: labels.toString() !== 'None' ? chartColors(data.size) : emptyColor,
        },
      ],
      labels,
    },
    options: {
      ...baseOptions,
      responsive: true,
      legend: {
        display: false,
      },
    },
  });
};
